import { useRef, useState } from 'react';
import { Dropdown, DropdownItem } from 'react-nested-dropdown';
import './menu.css';
import 'react-nested-dropdown/dist/styles.css';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { getImageUrl } from '../../../../../utils/image-helper/get-image-url';

type MenuProps = {
    onAddNewModel: (file: File) => void;
};

export const Menu = ({ onAddNewModel }: MenuProps) => {
    const fileInputRef = useRef<HTMLInputElement>();
    const [inputKey, setInputKey] = useState(0);
    const [isShortcutKeysModalOpen, setIsShortcutKeysModalOpen] = useState(false);

    const menuitems: { menuitemName: string; items: DropdownItem[] }[] = [
        {
            menuitemName: 'Hozzáadás',
            items: [
                {
                    label: 'Modell importálása',
                    onSelect: () => {
                        if (fileInputRef.current) fileInputRef.current.click();
                    }
                }
            ]
        },
        {
            menuitemName: 'Segítség',
            items: [
                {
                    label: 'Gyorsbillentyűk',
                    onSelect: () => setIsShortcutKeysModalOpen(true)
                }
            ]
        }
    ];

    const handleFileInputChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
        if (event.target.files && event.target.files.length > 0) {
            onAddNewModel(event.target.files[0]);
            setInputKey(inputKey + 1);
        }
    };

    return (
        <>
            <div className="module-space-editor-menu">
                {
                    menuitems.map(menuitem => (
                        <Dropdown items={menuitem.items} key={menuitem.menuitemName}>
                            {({ isOpen, onClick }) => (
                                <span className='menuitem' onClick={onClick}>
                                    {menuitem.menuitemName}
                                </span>
                            )}
                        </Dropdown>
                    ))
                }
            </div>
            <input
                key={inputKey}
                type='file'
                accept='.3dm, .glb, .gltf, .obj, .drc, .fbx, .3ds'
                ref={fileInputRef as React.RefObject<HTMLInputElement>}
                style={{ display: 'none' }}
                onChange={handleFileInputChange}
            />

            <Modal
                className="shortcut-keys-modal"
                isOpen={isShortcutKeysModalOpen}
                toggle={() => setIsShortcutKeysModalOpen(!isShortcutKeysModalOpen)}
            >
                <ModalHeader className="d-block">
                    <div className="d-flex justify-content-between align-items-center blue-font">
                        <b>Gyorsbillentyűk</b>
                        <img
                            style={{ width: '50px', padding: '10px 10px 0 0' }}
                            src={getImageUrl('close-button.png')}
                            alt="close-button"
                            title="Bezárás"
                            className="cursor-pointer"
                            onClick={() => setIsShortcutKeysModalOpen(false)}
                        />
                    </div>
                </ModalHeader>
                <ModalBody>
                    <p>
                        Ugrás a modellhez: dupla kattintás
                    </p>
                    <h6>Kijelölt objektum változtatása:</h6>
                    Pozició: "<b>t</b>"
                    <br />
                    Rotáció: "<b>r</b>"
                    <br />
                    Scale(méretarány): "<b>s</b>"
                    <br />
                    Törlés: "<b>delete</b>"
                </ModalBody>
            </Modal>
        </>
    );
};